import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import TextInputField from "../../components/forms/TextInputField";
import DropDownInputField from "../../components/forms/DropDownInputField";
import ValueField from "../../components/forms/ValueField";
import FormError from "../../components/forms/FormError";

class ChangeWarehouseForm extends Component {

  render() {
    let {errors, handleSubmit, submit, warehouses, submitting, selectedWarehouseIsRecommended} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 

    let recommendedWarehouseInfo = null;
    if (selectedWarehouseIsRecommended) {
      recommendedWarehouseInfo = <ValueField label="" value="Warehouse recommended for shipment" />
    }
    let reasonElement = null;
    if (this.props.showReason) {
      reasonElement = <Field 
              label="Reason"
              name="reason"
              component={TextInputField}
              serverError={this.props.errors.reason}
              />
    }
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field 
              label="Warehouse"
              name="warehouseId"
              component={DropDownInputField}
              data={warehouses}
              valueKey="id"  
              titleKey="label" 
              showBlank={true}
              serverError={this.props.errors.warehouseId}
              />
              {reasonElement}
              {recommendedWarehouseInfo}
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
          <ActionButton label="Auto Select" active={!selectedWarehouseIsRecommended} onClick={this.props.onAutoSelect} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "ChangeWarehouseForm"
})(ChangeWarehouseForm);


ChangeWarehouseForm.defaultProps = {
  showReason: true
}

export default ReduxForm;